import { IProfesseur } from './professeur.model';

export enum MoisScolaire {
  JANVIER = 'JANVIER',
  FEVRIER = 'FEVRIER',
  MARS = 'MARS',
  AVRIL = 'AVRIL',
  MAI = 'MAI',
  JUIN = 'JUIN',
  JUILLET = 'JUILLET',
  AOUT = 'AOUT',
  SEPTEMBRE = 'SEPTEMBRE',
  OCTOBRE = 'OCTOBRE',
  NOVEMBRE = 'NOVEMBRE',
  DECEMBRE = 'DECEMBRE',
}

export enum StatutSalaire {
  CREE = 'CREE',
  EN_ATTENTE = 'EN_ATTENTE',
  PAYEE = 'PAYEE',
}

export enum MoyenPaiement {
  OM = 'OM',
  WAVE = 'WAVE',
  ESPECE_CHECK = 'ESPECE_CHECK',
}

export interface ISalaire {
  id?: string;
  montant: number;
  professeurId?: string;
  salaireGroupId: string;
  dateEmission?: string;
  statutSalaire?: StatutSalaire;
  numeroSalaire: string;
  datePaiement?: string;
  moyenPaiement?: MoyenPaiement;
  frais?: number;
  brut?: number;
  retenue?: number;
  net?: number;
  page?: number;
  size?: number;
  professeur?: IProfesseur | null;
  salaireGroup?: ISalaireGroup | null;
}

export interface SalaireDetails {
  id: string;
  matricule?: string;
  montant: number;
  professeurId: string;
  numeroTelephonePaiement: string;
  salaireGroupId: string;
  salaireGroup: string;
  dateEmission: string;
  statutSalaire: StatutSalaire;
  numeroSalaire: string;
  datePaiement?: string;
  moyenPaiement?: MoyenPaiement;
  frais?: number;
  brut?: number;
  retenue?: number;
  net?: number;
  professeur: string;
}

export interface ISalaireGroup {
  id?: string;
  mois: MoisScolaire;
  annee: number;
  statut?: StatutSalaire;
  dateDebut?: string;
  ecoleId: string;
}

export interface ISalaireDashboard {
  totalPaye?: number;
  totalNonPaye?: number;
  totalEnAttente?: number;
  totalNetPaye?: number;
  totalNetEnAttente?: number;
  totalNetNonPaye?: number;
  totalNet?: number;
  totalRetenueBRS?: number;
  totalFrais?: number;
  totalWave?: number;
  totalOM?: number;
}

export const defaultSalaireDashboardData: Readonly<ISalaireDashboard> = {
  totalPaye: 0,
  totalNonPaye: 0,
  totalEnAttente: 0,
  totalNetPaye: 0,
  totalNetEnAttente: 0,
  totalNetNonPaye: 0,
  totalNet: 0,
  totalRetenueBRS: 0,
  totalFrais: 0,
  totalWave: 0,
  totalOM: 0,
};

export interface ISalaireGroupDTO {
  ecoleId: string;
  mois?: MoisScolaire;
  anneeScolaireId: string;
}

export interface ISalaireRelanceDTO {
  salaireId: string;
  moyenPaiement?: MoyenPaiement;
  numeroPaiement?: string;
}

export const defaultSalaireValue: Readonly<SalaireDetails> = {
  montant: 0,
  salaireGroupId: '',
  salaireGroup: '',
  numeroTelephonePaiement: '',
  professeurId: '',
  numeroSalaire: '',
  professeur: '',
  dateEmission: '',
  statutSalaire: StatutSalaire.CREE,
  datePaiement: '',
  moyenPaiement: MoyenPaiement.ESPECE_CHECK,
  frais: 0,
  brut: 0,
  retenue: 0,
  net: 0,
  id: '',
};

export const defaultSalaireGroupValue: Readonly<ISalaireGroup> = {
  id: '',
  mois: MoisScolaire.JANVIER,
  annee: 0,
  statut: StatutSalaire.CREE,
  dateDebut: '',
  ecoleId: '',
};

export interface SalaireParams {
  anneeScolaireId: any;
  ecoleid: string;
  salaireGroupId: string;
  salaireId: string;
}

export interface SalaireDto {
  salaireGroupId: string;
  page: number;
  size: number;
}
